export default __webpack_public_path__ + "static/media/background-1.c18b992b.jpg";